/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type CountryResource = {
    /**
     * Transform the resource into an array.
     * Used when viewing an organization/country
     */
    id: number
    name: string
    abbreviation: string
    abbreviation_2: string
    currency: string
    currency_symbol: string
    date_format: CountryResource.date_format
    sms_prefix: string
}

export namespace CountryResource {
    export enum date_format {
        MDY = 'MDY',
        DMY = 'DMY',
        YMD = 'YMD'
    }
}
